import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subject } from 'rxjs';

import { AppLogger, Tabs } from 'app-core';
import { DialogService } from 'app-shared-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { MajorCategories } from '@alpha/types';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [DialogService],
})
export class AppointmentComponent implements OnInit, OnDestroy {
  @ViewChild('clinicProfile', { static: true })
  public clinicProfileTemplate!: TemplateRef<any>;
  @ViewChild('clinicServices', { static: true })
  public clinicServicesTemplate!: TemplateRef<any>;
  @ViewChild('prescriptionTemplate', { static: true })
  public prescriptionTemplate!: TemplateRef<any>;
  @ViewChild('reportsTemplate', { static: true })
  public reportsTemplate!: TemplateRef<any>;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public items: Array<Tabs> = [];
  public selectedItemIndex = 0;
  public tabLoaded: boolean[] = [false, false];

  public constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _route: Router,
  ) {}

  public ngOnInit(): void {
    const route = this._route.url.split('/');
    const routeFragment = this._route.url.split('/');
    if (routeFragment.some((item) => item === 'services')) {
      this.selectedItemIndex = 1;
    } else if (routeFragment.some((item) => item === 'prescription')) {
      this.selectedItemIndex = 2;
    } else if (routeFragment.some((item) => item === 'reports')) {
      this.selectedItemIndex = 2;
    } else {
      this.selectedItemIndex = 0;
    }

    this.items = [
      {
        label: 'Appointment Details',
        content: this.clinicProfileTemplate,
        index: 0,
        routeLink:
          route[2] === 'view'
            ? `appointment/view/appointment/${route[4]}/${route[5]}/${route[6].split('?')[0]}`
            : `appointment/appointment/${route[3]}/${route[4].split('?')[0]}`,
      },
      {
        label: 'Clinic Services',
        content: this.clinicServicesTemplate,
        index: 1,
        routeLink:
          route[2] === 'view'
            ? `appointment/view/services/${route[4]}/${route[5]}/${route[6].split('?')[0]}`
            : `appointment/services/${route[3]}/${route[4].split('?')[0]}`,
      },
    ];

    if (
      route[2] === 'view' &&
      Number(this._activatedRoute.snapshot.queryParamMap.get('acf')) ===
        Number(MajorCategories.Doctor)
    ) {
      this.items.push({
        label: 'Prescription',
        content: this.prescriptionTemplate,
        index: 2,
        routeLink: `appointment/view/prescription/${route[4]}/${route[5]}/${route[6].split('?')[0]}`,
      });
    }

    if (
      route[2] === 'view' &&
      Number(this._activatedRoute.snapshot.queryParamMap.get('acf')) ===
        Number(MajorCategories.BodyScan)
    ) {
      this.items.push({
        label: 'Reports',
        content: this.reportsTemplate,
        index: 2,
        routeLink: `appointment/view/reports/${route[4]}/${route[5]}/${route[6].split('?')[0]}`,
      });
    }

    this._cdRef?.markForCheck();
  }

  public tabChange(selectedItem: MatTabChangeEvent): void {
    this.selectedItemIndex = this.items.findIndex(
      (item) => item.index === selectedItem.index,
    );
    if (!this.tabLoaded[this.selectedItemIndex]) {
      this.tabLoaded[this.selectedItemIndex] = true;
    }
    // Get the current URL without query params
    const newUrl = `${this.items[this.selectedItemIndex].routeLink}`;
    this._route
      .navigate([newUrl], { queryParamsHandling: 'preserve' })
      .catch((err: string | Error) => AppLogger.Error(err));
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
